module.exports = "<div class=\"bg-light lter b-b wrapper-md\">\n  <h1 class=\"error-code text-warning text-center\"> Maintenance Mode</h1>\n  <br>\n  <p class=\"h3 text-thin pad-btm mar-btm text-center\">\n    <i class=\"fa fa-exclamation-circle fa-fw\"></i>\n    Temporarily Unavailable! Site is under maintenance from 12 AM to 4 AM..\n  </p>\n  <br>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/maintenance-mode/maintenance-mode.component.html
// module id = ../../../../../src/app/common/maintenance-mode/maintenance-mode.component.html
// module chunks = 0